import {
  createContext,
  React,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import MainPageDialog, {
  PageDialogContent,
  PageDialogFooter,
} from "../../components/dialog";
import { useForm } from "react-hook-form";
import { useGetReferralsMetaQuery } from "../../services/referralService";
import { useGetRadiologyFileUidMutation } from "../../services/shareDataService";
import FullScreenLoader from "../../components/FullScreenLoader";
import { getReferralsPrototype } from "./Referrals.data";
import { useGetReferralsQuery } from "../../services/referralsService";
import { AppListing } from "../../components/AppListing/Listing.view";
import moment from "moment";
import { FiSend } from "react-icons/fi";

const ReferralsMetaContext = createContext({});

export function useReferralsMetaContext() {
  return useContext(ReferralsMetaContext);
}

export const Referrals = (props) => {
  const { ...formHandler } = useForm({
    defaultValues: {},
  });
  // const { actions: allSliceAction } = providerNoteSlice;

  const [ItemList, setListData] = useState([]);
  const [preview, setPreview] = useState(false);
  const [openReferralForm, setOpenReferralForm] = useState(false);
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);
  const [showPrintRad, setShowPrintRad] = useState(false);
  const [uid, setUid] = useState("");
  const [selectedData, setSelectedData] = useState();
  const [referralsMeta, setReferralsMeta] = useState({});
  const [showPrintShareView, setShowPrintView] = useState(false);
  const [formData, setReferralFormData] = useState(getReferralsPrototype());
  const [uploadFileId, setUploadFileId] = useState(false);
  const [setIsPreviewLoading, setIsLoading] = useState(false);
  const {
    practice: { id: practiceId },
    auth: authToken,
  } = JSON.parse(localStorage.getItem("auth"));
  const {
    data: listingData,
    isLoading,
    isFetching,
  } = useGetReferralsQuery({ pid: props?.selectedChat?.pid });
  const { data: MetaData } = useGetReferralsMetaQuery({
    pid: props?.selectedChat?.pid,
  });
  const [fileUid] = useGetRadiologyFileUidMutation();
  // const [removeReferrals, { isLoading: removeReferralsLoading }] = useDeleteReferralMutation();
  useEffect(() => {
    if (MetaData) {
      // console.log(MetaData,"")
      let meta = { ...MetaData };
      let user_groups = [];
      if (MetaData?.task_group?.length > 0) {
        user_groups = [...MetaData.task_group, ...MetaData.provider_list];
      }
      meta.user_groups = user_groups;
      setReferralsMeta(meta);
    }
  }, [MetaData]);
  useEffect(() => {
    if (listingData) {
      setListData(listingData);
    }
  }, [listingData]);

  function getRefNoData(item) {
    return (item.referral_no || "-") + " / " + (item.provider_auth_no || "-");
  }
  const handlePrintRadiology = (item) => {
    setIsLoading(true);
    fileUid({ radiology_id: item?.radiology_id }).then((res) => {
      setIsLoading(false);
      if (res.data == null) {
        toast.error("Radiology order not found.");
      } else {
        setShowPrintRad(true);
        setUid(res?.data?.data);
      }
    });
  };
  const afterSubmit = (res) => {
    let notify = {
      open: true,
      type: "success",
      title: "Success",
    };
    if (res.data && res.data.code == 0) {
      notify.msg = res.data.msg;
    } else {
      notify.type = "error";
      notify.title = "Failed";
      notify.msg = res.msg;
    }
    // dispatch(
    //   allSliceAction.initNotificationDialog({ data: { ...notify } })
    // );
  };
  const advanecdSearchFields = [
    { title: "Reason", key: "reason", type: "text" },
    {
      title: "Referred To",
      key: "referring_to",
      type: "provider_search",
      showLabel: "name",
      optionData: [],
      width: "4",
    },
    { title: "Referral No.", key: "referral_no", type: "text" },
    { title: "PAN / Auth No.", key: "provider_auth_no", type: "text" },
    { title: "Date From", key: "created_from", type: "date" },
    { title: "Date To", key: "created_to", type: "date" },
    {
      title: "Referral Status",
      key: "referral_status",
      type: "local_search",
      metaKey: "OverAllReferenceTypes",
      type: "local_search",
      showLabel: "title",
      multiple: true,
    },
  ];

  const basicSearchFields = [
    {
      title: "Keyword",
      key: "Keyword",
      name: "keyword",

      value: "",
      placeholder: "Search by Type, Reason, Referral No. or Auth No.",
      width: "4",
      type: "text",
    },
  ];

  const cols = [
    {
      title: "Referred To Date",
      key: "referred_to_date",
      type: "date",
      getData: (item) => {
        const date = moment(item.referred_to_date).format("MM/DD/yyyy hh:mm A");
        return moment(date).isValid() ? date : "-";
      },
      colWidth: "2",
    },
    { title: "Reason", key: "reason", colWidth: "1" },
    { title: "Referral/Auth No.", colWidth: "2", getData: getRefNoData },
    {
      title: "Referring Provider",
      key: "referring_by_name",
      colWidth: "2",
      getData: (item) => {
        return (
          <div className="flex items-center gap-1">
            {item?.referring_by_name}{" "}
            {item.is_referral_sent && (
              <FiSend onClick={() => printHandler(item, "preview")} />
            )}{" "}
          </div>
        );
      },
    },
    { title: "Referred To", key: "referring_to_name", colWidth: "2" },
    {
      title: "Status",
      key: "referral_status_title",
      colWidth: "1",
      getData: (item) => {
        return (
          <div className="flex">
            {item?.referral_status_title}
            {item?.radiology_id != "" && item?.radiology_id != "0" && (
              <div
                className=" px-1.5 cursor-pointer"
                onClick={() => handlePrintRadiology(item)}
                title="Print and share Radiology"
              >
                <img src={icReferrals} className="w-5 h-5" alt="" />
              </div>
            )}
          </div>
        );
      },
    },
    { title: "Last Updated By ", key: "updated_by_name", colWidth: "2" },
    // { title: "Actions", key: "actions", colWidth: "1" }
  ];
  const printHandler = (item, type) => {
    if (type == "preview") {
      setPreview(true);
      setShowPrintView(true);
      setUploadFileId({ ...item, uuid: item.referral_sent_uuid?.uuid });
    } else {
      //   setPreview(false)
      // ReferralsService.getReferralPrintId({id:item.id}).then((res)=>{
      //   if (res?.data?.response.code==0){
      //   setShowPrintView(true);
      //   setUploadFileId({ ...item, uuid: res?.data?.response.data })}
      // })
    }
  };

  const actions = [
    { label: "Edit", onClick: (e, item) => openReferralsForm(item) },
    {
      label: "Print/Share",
      onClick: (e, item) => {
        printHandler(item);
      },
    },
    {
      label: "Delete",
      labelStyle: "text-red-500",
      onClick: (e, item) => {
        setSelectedData(item);
        setDeleteConfirmation(true);
      },
    },
  ];

  function searchReferral(params) {
    listReferrals(params);
  }

  function listReferrals(searchParams) {
    let params = { pid: props?.selectedChat?.pid, ...searchParams };
    if (params?.referring_to) {
      params.referring_to = params?.referring_to?.id;
    }
    if (params?.referral_status) {
      params.referral_status = params?.referral_status?.reduce(function (a, b) {
        return b.option_id + "," + (a.option_id || a);
      }, "");
    }
    // ReferralsService.getReferralsList(params).then((res) => {
    //   const { data } = parseResponse(res);
    //   setListData(data);
    //   console.log("ItemList", ItemList);
    // });
  }

  function openReferralsForm(item) {
    if (item) {
      setReferralFormData(item);
      //heree
      // dispatch(
      //   setReferral({
      //     data:
      //     {
      //       ...item,
      //       full_name: "",
      //       phone_home: "",
      //     },
      //     flow: ""
      //   })
      // );
    } else {
      // dispatch(
      //   setReferral({ data: "", flow: "" })
      // );
    }
    // setReferralsView('form');
  }

  function onSubmitForm(data) {
    // console.log("form submitted successfully");
  }

  function submitReferralsForm() {}

  // const buttons = [{ title: "Submit", onClick: onSubmitForm }];
  //  const closeReferralForm = () => {
  //   setReferralFormData(getReferralsPrototype());
  //    setReferralsView('list');
  //    if (referralflow == "assesment") {
  //     setOpenReferralsDialog(false)
  //    }
  //    actions.initNotificationDialog({ data: { ...notify } })

  //  };
  return (
    <>
      {
        // referralsView == 'list'
        true ? (
          <>
            {/* {(removeReferralsLoading || setIsPreviewLoading )&& (
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none before:absolute before:flex before:bg-black/25 before:w-full before:h-full z-30">
              <Loader />
            </div>
          )} */}

            {/* {deleteConfirmation && (
            <ActionDialog
              onCancelHandler={() => setDeleteConfirmation(false)}
              setShowModal={() => setDeleteConfirmation(false)}
              onConfirmHandler={() => { removeReferrals({ id: selectedData.id, encounter: selectedNote?.encounter }).then((res) => { afterSubmit(res) }); setDeleteConfirmation(false) }}
              showModal={deleteConfirmation}
              //title={title}
              title="Are you sure you want to delete this referral?"
            />
          )} */}

            {/* {showPrintShareView && (
            <PrintProcedures
              hideFooterBtn={!preview}
              title="Referral"
              userUniqueId={{...uploadFileId,title:"Referral Document"}}
              getFileUrl={getFileUrl}
              printLink={"utilities/get_attachment.json?attachment"}
              printData={uploadFileId}
              setShowPrintShareView={setShowPrintView}
            />
          )} */}
            {/* {showPrintRad && (
            <PrintProcedures
            title="Radiology"
              getFileUrl={getFileUrl}
              printLink={"efax/read_document/?file_name="}
              printData={printRadObj}
              setShowPrintShareView={setShowPrintRad}
              userUniqueId={printRadObj}
            />
          )} */}
            <div className="p-2 overflow-scroll">
              <ReferralsMetaContext.Provider value={referralsMeta}>
                {/* <SearchFilterUpdated
                metaContext={useReferralsMetaContext}
                formHandler={formHandler}
                basicSearch={basicSearchFields}
                advanceSearch={advanecdSearchFields}
                searchCallback={searchReferral}
              /> */}
              </ReferralsMetaContext.Provider>

              <p className="py-2 max-h-20 text-right">
                {!props?.shareDataDetail && (
                  <CommonLib.BtnComponent
                    btnType="default"
                    text="Add Referral"
                    onClick={() => openReferralsForm()}
                  />
                )}
              </p>
              <div className="text-left">
                <AppListing
                  showColorCode={practiceId == 387 || practiceId == 111}
                  listData={ItemList}
                  cols={cols}
                  selection={props?.shareDataDetail ? true : false}
                  toggleSelectItem={(data) => {
                    props?.setSelectedTableData(null);
                    props?.setSelectedTableData(data);
                  }}
                />
              </div>
            </div>
          </>
        ) : (
          <>
            {/* <ReferralForm
          printHandler={printHandler}
          formData={formData}
          onSubmit={closeReferralForm}
          closeHandler={closeReferralForm}
          fromWhere={props.fromWhere}
        /> */}
          </>
        )
      }
    </>
  );
};

export const ReferralsView = () => {
  return (
    <>
      <section className="mt-6">
        {/* <MainPageHeader /> */}
        <div className="pb-24">
          <div className="mt-4 p-4">
            <Referrals />
          </div>
        </div>
      </section>
    </>
  );
};

export const ReferralsDialog = (props) => {
  const {shareDataDetail}=props
  const [selectedTableData, setSelectedTableData] = useState([]);

  const footerList = [
    props?.shareDataDetail && {
      type: "save",
      action: () => props?.shareDataDetail?.attachHandler(selectedTableData),
      title: "Attach",
    },
    {
      type: "cancel",
      action: () =>
        props?.shareDataDetail
          ? props?.shareDataDetail?.closeDialog()
          : closeHandler(),
      title: "Close",
    },
  ];
  return (
    <MainPageDialog
      title="Attach Referral"
      footer={true}
      footerList={footerList}
      onCancelHandler={() => shareDataDetail?.closeDialog()}
    >

      <>
        <Referrals setSelectedTableData={setSelectedTableData} {...props} />
      </>
    </MainPageDialog>
  );
};
